"use strict";
exports.__esModule = true;
function generateColDef(headerMap, decimals) {
    return headerMap.map(function (header) { return ({
        name: header['key'],
        displayName: header['text'],
        pinnedLeft: header['key'] === 'id',
        pinnedRight: !header['pjStat'] && !(header['key'] === 'id'),
        minWidth: 90,
        width: header['pjStat'] ? undefined : 90,
        hidePinRight: header['pjStat'] ? header['pjStat'] : false,
        // headerTooltip: true,
        enableSorting: false,
        cellFilter: !header['pjStat'] && !(header['key'] === 'id') ? 'number: '.concat(decimals) : undefined
    }); });
}
function getFilterKey(cateName) {
    return "filter_" + cateName;
}
function getFilterCategory(filter) {
    // Example: '(Region:Europe or Region:US or Region:Asia)'
    var entries = filter.trim().replace(/[()]/, '').split('or');
    if (entries && entries.length > 0) {
        return entries[0].split(':')[0].trim();
    }
    return null;
}
function addFiltersToHeaders(tableHeaders, filterCategories) {
    filterCategories.forEach(function (cate) {
        tableHeaders.push({
            'key': getFilterKey(cate),
            'text': "Filter: " + cate
        });
    });
}
function processRowWithFilters(row, filterCategories) {
    if (!row.tags) {
        return;
    }
    var tags = row.tags.filter(function (t) { return t !== 'all'; });
    tags.sort();
    filterCategories.forEach(function (cate) {
        var cateResult = [];
        tags.forEach((function (tag) {
            var _a = tag.split(':'), c = _a[0], t = _a[1];
            if (c === cate) {
                cateResult.push(t);
            }
        }));
        row[getFilterKey(cate)] = cateResult.join(',');
    });
}
function processTableWithFilters(tableData, filterCategories) {
    if (!tableData || tableData.length < 1) {
        return;
    }
    tableData.forEach(function (row) {
        processRowWithFilters(row, filterCategories);
    });
}
function addColorToHeaders(tableHeaders, colorKey) {
    if (colorKey) {
        tableHeaders.push({
            'key': 'colorTag',
            'text': "Color By: " + colorKey.replace(/[<>]/g, '')
        });
    }
}
function formatCell(val, decimalPoint) {
    if (typeof val === 'undefined' || val === null) {
        return '""';
    }
    var str = val.toString().trim();
    if (!isNaN(val)) {
        return str.replace('.', decimalPoint);
    }
    return "\"" + str + "\"";
}
var EFPortTable = /** @class */ (function () {
    function EFPortTable() {
    }
    EFPortTable.generateGridOptions = function (_a, decimals) {
        var inputData = _a.inputData, mainNodeName = _a.mainNodeName, siblingNodeName = _a.siblingNodeName, reportOptions = _a.reportOptions;
        var tableHeaders = inputData.headerMap;
        var mainTable = inputData.mainRows;
        var siblingTableHeaders = inputData.siblingHeaderMap;
        var siblingTable = inputData.siblingRows;
        var filterLogic = reportOptions.filterLogic, groupKey = reportOptions.groupKey, colorKey = reportOptions.colorKey;
        if (filterLogic && !groupKey) {
            var filterCategories = filterLogic.split('and').map(function (filter) { return getFilterCategory(filter); });
            addFiltersToHeaders(tableHeaders, filterCategories);
            processTableWithFilters(mainTable, filterCategories);
            processTableWithFilters(siblingTable, filterCategories);
        }
        addColorToHeaders(tableHeaders, colorKey);
        var colDef = generateColDef(tableHeaders, decimals);
        var res = {};
        res.main = {
            name: mainNodeName,
            data: mainTable,
            columnDefs: colDef,
            enableSorting: false
        };
        if (siblingTable && siblingTable.length > 0) {
            var siblingColDef = generateColDef(siblingTableHeaders, decimals);
            var siblingColor = siblingTable[0].color;
            res.sibling = {
                name: siblingNodeName,
                data: siblingTable,
                columnDefs: siblingColDef,
                enableSorting: false,
                color: siblingColor
            };
        }
        return res;
    };
    EFPortTable.generateCsv = function (gridOptions, csvFormat) {
        if (!gridOptions) {
            return '';
        }
        var colDefs = gridOptions.columnDefs;
        var rows = gridOptions.data;
        var cellSeparator = csvFormat === 'EU' ? ';' : ',';
        var decimalPoint = csvFormat === 'EU' ? ',' : '.';
        var colHeadersMod = [
            { name: 'name', displayName: 'Portfolio Elements' }
        ].concat(colDefs);
        var lines = [];
        lines.push(colHeadersMod.map(function (header) { return formatCell(header['displayName'], decimalPoint); }).join(cellSeparator));
        rows.forEach(function (row) {
            if (row) {
                lines.push(colHeadersMod.map(function (x) { return formatCell(row[x.name], decimalPoint); }).join(cellSeparator));
            }
        });
        return lines.join('\n');
    };
    return EFPortTable;
}());
exports.EFPortTable = EFPortTable;
//# sourceMappingURL=efport-table.logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/efport-table/efport-table.logic.js